import React from "react"
import { RenderElementProps } from "slate-react"

const CopytextImageTextSlider = ({ children, attributes }: RenderElementProps) => {
    return (
        <p {...attributes} className="mb-5 text-md last:mb-0 lg:text-lg">
            {children}
        </p>
    )
}

export default CopytextImageTextSlider
